var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCompany = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54313 5.16667V12.6667M5.87646 5.16667V12.6667M10.8765 5.16667V12.6667M14.2098 5.16667V12.6667M15.8765 16V15.3333C15.8765 14.3999 15.8765 13.9332 15.6948 13.5767C15.535 13.2631 15.2801 13.0081 14.9664 12.8483C14.6099 12.6667 14.1432 12.6667 13.2098 12.6667H3.54313C2.60971 12.6667 2.143 12.6667 1.78648 12.8483C1.47288 13.0081 1.21791 13.2631 1.05812 13.5767C0.876465 13.9332 0.876465 14.3999 0.876465 15.3333V16H15.8765ZM0.876465 3.08333V5.16667H15.8765V3.08333L8.37646 1L0.876465 3.08333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCompany);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconCompany.3fba49e2d1820249e482a0be894bb11d.svg";